"use client";
import * as React from 'react';
import { Toast as ToastPrimitive } from '@base-ui/react/toast';
import { X } from 'lucide-react';

export const Toast=ToastPrimitive;
export const createToastManager=ToastPrimitive.createToastManager;
export const toastManager=createToastManager();
export const ToastProvider=ToastPrimitive.Provider;
export const ToastViewport=ToastPrimitive.Viewport;
export const ToastRoot=ToastPrimitive.Root;
export const ToastTitle=ToastPrimitive.Title;
export const ToastDescription=ToastPrimitive.Description;
export const ToastAction=ToastPrimitive.Action;
export const ToastClose=ToastPrimitive.Close;
export const useToastManager=ToastPrimitive.useToastManager;
function ToastList(){const {toasts}=ToastPrimitive.useToastManager();return <ToastPrimitive.Portal><ToastPrimitive.Viewport className="freeui-toast-viewport">{toasts.map(toast=><ToastPrimitive.Root key={toast.id} toast={toast} className="freeui-toast" swipeDirection="right"><ToastPrimitive.Content><ToastPrimitive.Title/><ToastPrimitive.Description/>{toast.actionProps&&<ToastPrimitive.Action {...toast.actionProps}/>}<ToastPrimitive.Close aria-label="Dismiss notification"><X size={14}/></ToastPrimitive.Close></ToastPrimitive.Content></ToastPrimitive.Root>)}</ToastPrimitive.Viewport></ToastPrimitive.Portal>;}
export function Toaster({children,...props}:React.ComponentProps<typeof ToastPrimitive.Provider>){return <ToastPrimitive.Provider toastManager={toastManager} {...props}>{children}<ToastList/></ToastPrimitive.Provider>;}
